(ns dashboard.entity.document.search
  "The principle contract of the dashboard.entity component namespaces are this:
     1. All components will NOT depend on keyword references to subs and events in
        external NSes, but rather receive data as arguments, functions and callbacks.
     2. All internal reliance on the re-frame app DB must be internally contained.
     3. All re-frame app subs and events must NOT be directly referenced by outside
        NSes, but rather via GETTER and SETTER functions - the same is true of internal
        calls - prefer using parameterized functions.
     4. The entity is a UI component that may encapsulate low-level business rules on
        UI controls, but is not responsible for hydrating components with data or entrenched
        references to component namespaces. The UI is customizable, and top-level entities
        should have configurable and interchangable UI elements."
  (:require ["react" :as react]
            [dashboard.components.search.search-box :as search.view]))



(defn search-results
  "Right-hand menu that displays document attribution and user selection tools"
  [{:keys [selected-paragraph
           document-id
           document-search-results
           on-set-document-search-results
           on-select-search-result]}]
  (let [[selected-ref set-selected-ref] (react/useState nil)
        [show-search set-show-search] (react/useState true)]
    (react/useEffect
     (fn []
       (when selected-ref
         (.scrollIntoView selected-ref #js{:behavior "smooth"
                                           :block "center"})))
     (array selected-ref))
    [:div.document-viewer-right-sidebar--search-results
     [:h5.title.is-size-5.mt-3 "Document Search"]
     (when show-search
       [:f> search.view/search-panel
        (fn [_ _ selection results]
          (on-select-search-result selection :result)
          (on-set-document-search-results results)
          (set-show-search false))
        false
        document-id])
     [:button.button.is-secondary
      {:on-click #(set-show-search not)}
      (if show-search
        [:<>
         [:i.icon.fas.fa-cancel.mr-3]
         "Cancel Search"]
        [:<>
         [:i.icon.fas.fa-search.mr-3]
         "Search"])]

     [:div.title.is-6.mb-2.mt-4 "All Search Results"]
     [:div (->> document-search-results
                (sort-by #(+ (:page %) (-> % :bounding-box :Top)))
                (map-indexed
                 (fn [idx {:keys [matched_content
                                  page
                                  document-paragraph-id]
                           :as paragraph}]
                   [:div
                    {:key document-paragraph-id
                     :ref (when (= document-paragraph-id
                                   (:document-paragraph-id selected-paragraph))
                            set-selected-ref)
                     :class (when (= document-paragraph-id
                                     (:document-paragraph-id selected-paragraph))
                              "search-results--search-result-content")}
                    [:a
                     {:on-click #(on-select-search-result paragraph :content)}
                     [:div.is-size-7
                      (inc idx)
                      ") Page "
                      page]
                     [:div
                      {:dangerouslySetInnerHTML
                       {:__html matched_content}}]
                     [:hr.my-1]]]))
                (into [:<>]))]]))
